module.exports = __webpack_public_path__ + "static/img/slider-3.077f251.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-3.jpg
// module id = ayEr
// module chunks = 1